import { Flex, Tag, Text, Tooltip, Wrap, WrapItem } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { EngineeringStatsItem } from '../../helpers/report.types';
import { formatNumber } from '../../helpers/report.utils';

const parseProductList = (
  value: EngineeringStatsItem['products']
): string[] => {
  if (value === null || value === undefined || value === '') return [];
  return String(value)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
};

const ProductsCell = ({
  value,
}: {
  value: EngineeringStatsItem['products'];
}) => {
  const items = parseProductList(value);
  if (items.length === 0) {
    return (
      <Text fontSize="sm" fontFamily="heading" color="text.secondary">
        -
      </Text>
    );
  }
  return (
    <Wrap spacing={1.5} rowGap={1.5} w="full" align="flex-start">
      {items.map((name, i) => (
        <WrapItem key={`${name}-${i}`}>
          <Tooltip label={name} hasArrow isDisabled={name.length < 28}>
            <Tag
              size="sm"
              variant="subtle"
              colorScheme="gray"
              fontFamily="heading"
              fontWeight="medium"
              fontSize="xs"
              px={2}
              py={0.5}
              borderRadius="md"
              maxW="100%"
              whiteSpace="normal"
              wordBreak="break-word"
            >
              {name}
            </Tag>
          </Tooltip>
        </WrapItem>
      ))}
    </Wrap>
  );
};

const renderValue = (
  value: EngineeringStatsItem[keyof EngineeringStatsItem],
  numeric?: boolean
): ReactNode => {
  if (value === null || value === undefined || value === '') return '-';
  if (numeric) return formatNumber(value);
  return String(value);
};

/** Stat / products cell for Contributor Report CSS Grid rows. */
export const EngineeringStatGridCell = ({
  row,
  field,
  numeric,
}: {
  row: EngineeringStatsItem;
  field: keyof EngineeringStatsItem;
  numeric?: boolean;
}) => {
  if (field === 'products') {
    return <ProductsCell value={row.products} />;
  }
  return (
    <Text
      fontSize="sm"
      fontFamily="heading"
      color="text.primary"
      fontWeight="normal"
      noOfLines={2}
      wordBreak="break-word"
    >
      {renderValue(row[field], numeric)}
    </Text>
  );
};
